import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'gas-icon-actions',
  templateUrl: './gas-icon-actions.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GasIconActionsComponent { }
